export const PROTOCOL_VERSION = 4;
export const WORLD_MAP_SCHEMA_VERSION = 1;
